import { Component, OnInit, Inject, ElementRef, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { FormGroup, FormControl } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { AppService } from 'src/app/appservice.service';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';

@Component({
  selector: 'app-new-item',
  templateUrl: './new-item.component.html',
  styleUrls: ['./new-item.component.css']
})
export class NewItemComponent implements OnInit {

  itemForm: FormGroup;
  taxgroups: any;
  itemtypes: any;
  UOMs: any;
  filteredOptions: Observable<string[]>;
  isSubmitting = false;
  selectedType = 1;

  constructor(public dialogRef: MatDialogRef<NewItemComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData, public translate: TranslateService, public service: AppService) {

    this.itemForm = new FormGroup({
      id: new FormControl(0),
      name: new FormControl(data.name),
      code: new FormControl(),
      rate: new FormControl(),
      unit: new FormControl(this.service.df_uom),
      group: new FormControl(),
      hsncode: new FormControl(this.service.df_hnscode),
      taxgroup: new FormControl(this.service.df_taxgroup),
      description: new FormControl(),
      warranty: new FormControl(),
      itemunitId: new FormControl(24), // Default to PCS (ID 24)
      itemtypeId: new FormControl(1), // Default to Line Item
      category: new FormControl('accessories')
    });
    //      this.taxes = this.filter();

    this.service.getRequest('api/getTaxGroups').subscribe(x => {
      this.taxgroups = x;
    });

    this.service.getRequest('api/getItemTypes').subscribe(x => {
      this.itemtypes = x;
      this.itemForm.controls.itemtypeId.patchValue(1);
    });

    this.service.getRequest('api/getUOM').subscribe(x => {
      this.UOMs = x;
      this.filteredOptions = this.itemForm.controls.unit.valueChanges
        .pipe(
          startWith(''),
          map(value => this._filter(value))
        );

      for (let i = 0; i < x.length; i++) {
        if (x[i].name === this.service.df_uom) {
          this.itemForm.controls.unit.patchValue(x[i]);
          break;
        }
      }
    });
    if (data.id != null && data.id > 0) {
      this.service.getRequest('api/items/' + data.id).subscribe(x => {
        this.itemForm.controls.id.patchValue(x.id);
        this.itemForm.controls.name.patchValue(x.name);
        this.itemForm.controls.code.patchValue(x.code);
        this.itemForm.controls.rate.patchValue(x.rate);
        this.itemForm.controls.unit.patchValue(x.itemunit);
        this.itemForm.controls.group.patchValue(x.group);
        this.itemForm.controls.hsncode.patchValue(x.hsncode);
        this.itemForm.controls.description.patchValue(x.description);
        this.itemForm.controls.warranty.patchValue(x.warranty);
        this.itemForm.controls.itemunitId.patchValue(x.itemunitId);
        this.itemForm.controls.itemtypeId.patchValue(x.itemtypeId);
        this.itemForm.controls.category.patchValue(x.category || 'accessories');
        if (this.service.istaxindividual) {
          this.itemForm.controls.taxgroup.patchValue(x.taxgroup);
        }
      });
    }
  }

  displayFn(item: any): string {
    this.UOMs = item;
    return item ? item.name : (item ? item.id.toString() : null);
  }


  ngOnInit() {
  }
  onNoClick(): void {
    this.dialogRef.close();
  }


  private _filter(value: any): string[] {
    const filterValue = value.name ? value.name.toLowerCase() : value.toLowerCase();

    return this.UOMs.filter(option => (option.description.toLowerCase().includes(filterValue)
      || option.name.toLowerCase().includes(filterValue)));
  }

  handleEnterKeyPress(event) {
    const tagName = event.target.tagName.toLowerCase();
    if (tagName !== 'textarea' && tagName !== 'button') {
      return false;
    }
  }

  onSubmit() {
    try {
      if (this.itemForm.valid) {
        if (this.itemForm.value.unit && this.itemForm.value.unit.id) {
          this.itemForm.value.itemunitId = this.itemForm.value.unit.id;
        }
        if (this.itemForm.value.taxgroup === null || this.itemForm.value.taxgroup === '') {
          this.itemForm.value.taxgroup = this.service.df_taxgroup;
        }

        this.service.getRequestData('api/items', this.itemForm.value).subscribe((data) => {
          console.log(data);
          if (data.Success) {
            this.data.name = this.itemForm.controls.name.value;
            this.dialogRef.close(data.data);
          } else {
            this.service.sendMessage('Item.CreateFailedRetry');
          }
        },
          (err) => {
            console.log('Item creation failed : ' + err);
            this.service.sendMessage('Oops');
          });
      } else {
        this.service.sendMessage('Item.FillAllDetails');
      }
    } catch (ex) {
      console.log(ex);
      this.service.sendMessage('Oops');
    } finally {
      this.isSubmitting = false;
    }
  }
}

export interface DialogData {
  id: number;
  name: string;
}
